"use client";
import { useCallback, useEffect, useState } from "react";
import InputRange, { Range } from "react-input-range"; // Import Range type
// import "react-input-range/lib/css/index.css"; // Import CSS
import { getUserCurrency } from "@/lib/features/home/homeSlice";
import { useAppSelector } from "@/lib/hooks";
import { loading } from "@/lib/features/hotel/hotelSlice";

interface PriceSliderProps {
  onPriceChange: (value: Range, currency: any) => void; // Use Range type
  onSearch: boolean;
  value: Range; // Use Range type
}

const PriceSlider = ({ onPriceChange, onSearch, value }: PriceSliderProps) => {
  const isLoading = useAppSelector(loading);
  const currency = useAppSelector(getUserCurrency);

  // Temporary local state for smooth sliding
  const [tempValue, setTempValue] = useState<Range>(value);

  // Sync tempValue with prop value when it changes
  useEffect(() => {
    setTempValue(value);
  }, [value]);

  const handleOnChange = useCallback((newValue: number | Range) => {
    // Since this is a range slider, we expect Range
    setTempValue(newValue as Range); // Type assertion since we only expect Range
  }, []);

  const handleOnChangeComplete = useCallback(
    (value: number | Range) => {
      const rangeValue = value as Range; // Type assertion for range slider
      onPriceChange(rangeValue, currency);
    },
    [onPriceChange, currency]
  );

 
  return (
    <div className="js-price-rangeSlider">
      <div className="d-flex justify-between">
        <div className="text-15 text-dark-1">
          <span className="js-lower mx-1">
            <span dangerouslySetInnerHTML={{ __html: currency?.html_entity || "" }}></span>
            {tempValue.min}
          </span>
          -
          <span className="js-upper mx-1">
            <span dangerouslySetInnerHTML={{ __html: currency?.html_entity || "" }}></span>
            {tempValue.max}
            {tempValue.max === (currency?.max ?? 700) && `+`}
          </span>
        </div>
      </div>

      <div className="px-3">
        <InputRange
          name="price"
          disabled={isLoading}
          step={currency?.step || 10}
          formatLabel={(value) => ``}
          minValue={currency?.min ?? 0}
          maxValue={currency?.max ?? 700}
          value={tempValue}
          onChange={handleOnChange}
          onChangeComplete={handleOnChangeComplete}
        />
      </div>
    </div>
  );
};

export default PriceSlider;